

document.addEventListener('DOMContentLoaded', ()=> {

  const loginButton = document.querySelector('[js-login-form-button]');
  const loginPage = document.querySelector('[js-login-page]');
  const loginForm = document.querySelector('[js-login-form]');
  const cancelButon = document.querySelector('[js-cancel-button]');

  if (loginButton) {
    loginButton.addEventListener('click', (e) => {
      e.preventDefault();

      if (loginPage) loginPage.classList.add('hidden');
      if (loginForm) loginForm.classList.remove('hidden');
    });
  }

  if (cancelButon) {
    cancelButon.addEventListener('click', (e) => {
      e.preventDefault();

      if (loginPage) loginPage.classList.remove('hidden');
      if (loginForm) loginForm.classList.add('hidden');
    });
  }
})